export default __webpack_public_path__ + "static/media/sign-in-kids.9a5b675c.png";